import { 
    FETCH_DATA_START, FETCH_DATA_SUCCESS, FETCH_DATA_FAILURE,    
    FILE_UPLOAD_START, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAILURE
} from "store/types/medical_record.type";

import {FileActions } from "store/actions/medical_records.action";
import { RootReducerType } from './index';
export type State = {
    loading: boolean;
    data: any;
    error: string | null;
    filePath: string | null;
}

const initialState: State = {
    loading: false,
    data: null,
    error: null,
    filePath: null
}

const medicalRecordReducer = (state = initialState, action: FileActions): State => {
    switch(action.type) {
        case FETCH_DATA_START:
            return {
                ...state,
                loading: true,
                error: null
            }
        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        case FETCH_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                data: null
            }
        case FILE_UPLOAD_START:
            return {
                ...state,
                loading: true
            };
        case FILE_UPLOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                filePath: action.payload,
                error: null
            };
        case FILE_UPLOAD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                filePath: null
            };
        default:
            return state;
    }
};

export const medicalRecordsSelector = (state: RootReducerType) => state.medicalRecords;
export default medicalRecordReducer;